module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline white--text"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.total)))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93e2c336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/TotalNumber.vue
// module id = 2237
// module chunks = 0